import React, { Component } from 'react';
import { makeObservable, observable, action } from 'mobx';
import { observer } from "mobx-react";
import FiltersStore from 'Stores/Metrics/FiltersStore';
import 'Styles/Metrics.scss';
import DateTimePicker from 'Components/Common/DateTimePicker';
import HelperDatePickerRange from "Utils/HelperDatePickerRange";
import ListBox from 'Components/Common/listBox';
import Helper from "Utils/Helper";
import { WebMetricDateRangePeriodType } from "Stores/models/Enums";

class MetricFilters extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        if (FiltersStore.initDataLoading)
            return "";

        return (
            <div className="Metrics-filters">
                <div className="Metrics-filters-rows">

                    <div className="Metrics-filter-title">
                        Период событий:
                    </div>
                    <div className="Metrics-filter-value">
                        <ListBox values={FiltersStore.filtersValues.filterPeriods}
                            selectedItem={FiltersStore.filtersRender.dateRangePeriodType}
                            onSelectedItemChanged={it => FiltersStore.filtersRender.dateRangePeriodType = it} />
                    </div>
                    {
                        FiltersStore.filtersRender.dateRangePeriodType != WebMetricDateRangePeriodType.custom ? null : [
                            <div className="Metrics-filter-title">
                                Дата события от:
                            </div>
                            ,
                            <div>
                                <DateTimePicker
                                    getRenderStore={() => FiltersStore.renderStore.filterDateFrom}
                                    setRenderStore={action(val => FiltersStore.renderStore.filterDateFrom = val)}
                                    getValue={() => FiltersStore.filtersRender.dateFrom}
                                    setValue={val => FiltersStore.filtersRender.dateFrom = val}
                                    getMinDate={() => HelperDatePickerRange.GetMinDateFrom()}
                                    getMaxDate={() => HelperDatePickerRange.GetMaxDateFrom(FiltersStore.filtersRender.dateTo)}
                                    timeVisible={false}
                                    canClear={false}
                                />
                            </div>
                            ,
                            <div className="Metrics-filter-title">
                                Дата события до:
                            </div>
                            ,
                            <div>
                                <DateTimePicker
                                    getRenderStore={() => FiltersStore.renderStore.filterDateTo}
                                    setRenderStore={action(val => FiltersStore.renderStore.filterDateTo = val)}
                                    getValue={() => FiltersStore.filtersRender.dateTo}
                                    setValue={val => FiltersStore.filtersRender.dateTo = val}
                                    getMinDate={() => HelperDatePickerRange.GetMinDateTo(FiltersStore.filtersRender.dateFrom)}
                                    getMaxDate={() => new Date()}
                                    timeVisible={false}
                                    canClear={false}
                                />
                            </div>
                        ]
                    }
                </div>
            </div>
        );
    }
}

export default observer(MetricFilters);